"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPERTY_DATA_TYPE_USER = exports.PROPERTY_DATA_TYPE_DATE = exports.PROPERTY_DATA_TYPE_TEXT = exports.PROPERTY_DATA_TYPE_STRING = exports.PROPERTY_DATA_TYPE_NUMBER = exports.CLAUSE_TYPE_FIELD_WAS = exports.CLAUSE_TYPE_FIELD_CHANGED = exports.CLAUSE_TYPE_FIELD_VALUE = exports.CLAUSE_TYPE_COMPOUND = exports.NODE_TYPE_CLAUSE = void 0;
exports.NODE_TYPE_CLAUSE = 'clause';
exports.CLAUSE_TYPE_COMPOUND = 'compound';
exports.CLAUSE_TYPE_FIELD_VALUE = 'field_value';
exports.CLAUSE_TYPE_FIELD_CHANGED = 'field_changed';
exports.CLAUSE_TYPE_FIELD_WAS = 'field_was';
exports.PROPERTY_DATA_TYPE_NUMBER = 'number';
exports.PROPERTY_DATA_TYPE_STRING = 'string';
exports.PROPERTY_DATA_TYPE_TEXT = 'text';
exports.PROPERTY_DATA_TYPE_DATE = 'date';
exports.PROPERTY_DATA_TYPE_USER = 'user';
//# sourceMappingURL=clause.js.map